module.exports = __webpack_public_path__ + "img/theo-celebrate.91508edb.png";